import { Text } from 'common/styles';
import styled from '@emotion/styled';

type StaticText = { lineHeight?: number, hideInMobile?: boolean };

const StaticText = styled(Text)<StaticText>(({ theme, lineHeight }) => ({
  lineHeight: lineHeight ? theme.spacings[lineHeight] : theme.spacings[5],
}));
export default StaticText;